import React from "react";
import "./GetTickets.css";
import NavBar from "../NavBar/NavBar";
import Footer from "../Footer/Footer";
import RecipientTicket from "../RecipientTicket/RecipientTicket";
import { SERVER_ADDRESS } from "../../../constants";

class GetTickets extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tickets: [],
        };

        this.getTickets = this.getTickets.bind(this);
        this.addRequest = this.addRequest.bind(this);
    }

    componentDidMount() {
        this.getTickets();
    }

    async getTickets() {
        return fetch(`${SERVER_ADDRESS}/tickets/available`, {
            headers: {
                "content-type": "application/json",
                "accept": "application/json"
            }
        }).then(response => {
            return response.json();
        }).then(tickets => {
            if(tickets[0]) {
                let filtered = tickets.filter(ticket => {
                    for(let i = 0; i<ticket.requests.length; i++) {
                        if(ticket.requests[i].email === this.props.user.email) {
                            return false
                        }
                    }
                    return true;
                })
                this.setState({tickets: filtered});
            } else {
                this.setState({tickets: []})
            }
        })
    }

    async addRequest(ticketID) {
        let data = JSON.stringify({
            email: this.props.user.email,
            timestamp: new Date().toDateString()
        });
        try {
            let result = await fetch(`${SERVER_ADDRESS}/tickets/request/${ticketID}`, {
                method: "PUT",
                body: data,
                headers: {
                    "content-type": "application/json",
                    "accept": "application/json"
                }
            })
            if(result) {
                this.getTickets();
            }
        } catch(error) {
            console.log(error);
        }
    }

    render() {
        return (
            <div>
                <NavBar/>
                <div className="recipient-container">
                    <h1 id="welcome-bar">Welcome back, {this.props.user.name}!</h1>
                    <div className="recipient-container" id="available-container">
                        {this.state.tickets.map(ticket => {
                            return <RecipientTicket key={ticket.id} addRequest={this.addRequest} ticket={ticket}/>
                        })}
                    </div>
                </div>
                <Footer/>
            </div>
        );
    }
}

export default GetTickets;